// Shared icon set for time-off categories. Extends the §8/§9 task-list icons
// (calendar, clipboard, refresh, person, gear, building, laptop, package, briefcase)
// with the 4 new §11 additions: palm-tree, medical-clipboard, medal, bandage.
// Valid codes must match backend TimeOffIconCodes.VALID.

type Props = {
  icon: string;
  className?: string;
};

export function TimeOffIconSvg({ icon, className = 'h-5 w-5' }: Props) {
  switch (icon) {
    case 'palm-tree':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <path d="M8 14V6" strokeLinecap="round" />
          <path d="M8 6C8 6 5 4.5 3 2c2.5 0 4.5 1.5 5 4z" strokeLinejoin="round" />
          <path d="M8 6C8 6 11 4.5 13 2c-2.5 0-4.5 1.5-5 4z" strokeLinejoin="round" />
          <path d="M8 9C8 9 5.5 8 4 6c2 0 3.5 1 4 3z" strokeLinejoin="round" />
          <path d="M8 9C8 9 10.5 8 12 6c-2 0-3.5 1-4 3z" strokeLinejoin="round" />
          <path d="M6 14h4" strokeLinecap="round" />
        </svg>
      );
    case 'medical-clipboard':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <rect x="4.5" y="2" width="7" height="2" rx="1" />
          <rect x="2.5" y="3" width="11" height="11" rx="1.5" />
          <path d="M8 6.5v4M6 8.5h4" strokeLinecap="round" />
        </svg>
      );
    case 'medal':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <circle cx="8" cy="10" r="4" />
          <path d="M6 2l2 3 2-3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6 2h4" strokeLinecap="round" />
          <path d="M7.5 8.5l.5 1 1.5-2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'bandage':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <rect x="2" y="5.5" width="12" height="5" rx="2.5" />
          <rect x="5.5" y="5.5" width="5" height="5" rx="0.5" />
          <circle cx="8" cy="8" r="0.75" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'calendar':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <rect x="2" y="3" width="12" height="11" rx="1" />
          <path d="M5 2v2M11 2v2M2 7h12" strokeLinecap="round" />
          <circle cx="5.5" cy="10.5" r="0.75" fill="currentColor" stroke="none" />
          <circle cx="8" cy="10.5" r="0.75" fill="currentColor" stroke="none" />
          <circle cx="10.5" cy="10.5" r="0.75" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'clipboard':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <rect x="4.5" y="2" width="7" height="2" rx="1" />
          <rect x="2.5" y="3" width="11" height="11" rx="1.5" />
          <path d="M5 8h6M5 11h4" strokeLinecap="round" />
        </svg>
      );
    case 'refresh':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <path d="M2.5 8A5.5 5.5 0 0 1 13.5 8" strokeLinecap="round" />
          <path d="M13.5 5l.5 3-3-.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M13.5 8A5.5 5.5 0 0 1 2.5 8" strokeLinecap="round" />
          <path d="M2.5 11L2 8l3 .5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'person':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <circle cx="8" cy="5" r="3" />
          <path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6" strokeLinecap="round" />
        </svg>
      );
    case 'gear':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <circle cx="8" cy="8" r="2" />
          <path d="M8 2v1.5M8 12.5V14M2 8h1.5M12.5 8H14M3.515 3.515l1.06 1.06M11.424 11.424l1.061 1.061M3.515 12.485l1.06-1.06M11.424 4.576l1.061-1.061" strokeLinecap="round" />
        </svg>
      );
    case 'building':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <rect x="2" y="3" width="12" height="11" rx="1" />
          <path d="M5 14V9h6v5M8 3V1" strokeLinecap="round" />
          <rect x="5.5" y="5.5" width="2" height="2" rx="0.5" />
          <rect x="8.5" y="5.5" width="2" height="2" rx="0.5" />
        </svg>
      );
    case 'laptop':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <rect x="2" y="3.5" width="12" height="8" rx="1" />
          <path d="M1 11.5h14" strokeLinecap="round" />
        </svg>
      );
    case 'package':
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <path d="M8 1.5L14 5v6L8 14.5 2 11V5l6-3.5Z" />
          <path d="M8 1.5v13M2 5l6 3.5L14 5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'briefcase':
    default:
      return (
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden="true">
          <rect x="2" y="6" width="12" height="8" rx="1.5" />
          <path d="M5.5 6V4.5a2.5 2.5 0 0 1 5 0V6" strokeLinecap="round" />
          <path d="M8 10.5v1" strokeLinecap="round" />
        </svg>
      );
  }
}

export { TIME_OFF_ICON_OPTIONS } from './timeOffIconOptions';
export type { TimeOffIconCode } from './timeOffIconOptions';
